export const PIN_LIMIT = 5;

export const COLUMN_CODES = [
  'manager',
  'status',
  'cs_role',
  'division',
  'clients_count',
  'akb',
  'sales',
  'orders',
  'orders_via_manager',
  'average_check',
  'comments',
];

export const COLUMN_META = {
  manager: {
    group: 'person',
    label: 'Менеджер',
    tableLabel: 'Менеджер',
    sort: 'last_name',
    width: 230,
    metric: false,
    locked: true,
  },
  status: {
    group: 'person',
    label: 'Статус',
    tableLabel: 'Статус',
    sort: 'status',
    width: 74,
    metric: false,
  },
  cs_role: {
    group: 'person',
    label: 'Роль',
    tableLabel: 'Роль',
    sort: 'cs_role',
    width: 180,
    metric: false,
  },
  division: {
    group: 'person',
    label: 'Дивизион',
    tableLabel: 'Дивизион',
    sort: 'division',
    width: 120,
    metric: false,
  },
  clients_count: {
    group: 'person',
    label: 'Клиентов',
    tableLabel: 'Клиенты',
    sort: 'clients_count',
    width: 76,
    metric: false,
  },
  akb: {
    group: 'metric',
    label: 'АКБ',
    tableLabel: 'АКБ',
    sort: 'akb',
    selectedWidth: 72,
    currentWidth: 128,
    metric: true,
  },
  sales: {
    group: 'metric',
    label: 'Продажи, ₽',
    tableLabel: 'Продажи, ₽',
    sort: 'sales',
    selectedWidth: 104,
    currentWidth: 168,
    metric: true,
  },
  orders: {
    group: 'metric',
    label: 'Заказы',
    tableLabel: 'Заказы',
    sort: 'orders',
    selectedWidth: 72,
    currentWidth: 128,
    metric: true,
  },
  orders_via_manager: {
    group: 'metric',
    label: 'Заказы через менеджеров',
    tableLabel: 'Через менеджера',
    sort: 'orders_via_manager',
    selectedWidth: 72,
    currentWidth: 128,
    metric: true,
  },
  average_check: {
    group: 'metric',
    label: 'Средний чек, ₽',
    tableLabel: 'Средний чек, ₽',
    sort: 'average_check',
    selectedWidth: 88,
    currentWidth: 144,
    metric: true,
  },
  comments: {
    group: 'metric',
    label: 'Комментарии',
    tableLabel: 'Комментариев написано',
    sort: 'comments',
    selectedWidth: 72,
    currentWidth: 128,
    metric: true,
  },
};

export const COLUMN_GROUPS = [
  { id: 'person', title: 'Менеджер' },
  { id: 'metric', title: 'Показатели' },
];

export function defaultColumns() {
  return COLUMN_CODES.map((code) => ({
    code,
    visible: true,
    pinned: code === 'manager',
  }));
}

export function normalizeColumns(list) {
  const byCode = new Map((list || []).map((item) => [item.code, item]));
  const ordered = [];
  (list || []).forEach((item) => {
    if (COLUMN_META[item.code] && !ordered.some((entry) => entry.code === item.code)) {
      ordered.push({
        code: item.code,
        visible: item.code === 'manager' ? true : Boolean(item.visible),
        pinned: item.code === 'manager' ? true : Boolean(item.pinned),
      });
    }
  });
  COLUMN_CODES.forEach((code) => {
    if (!ordered.some((item) => item.code === code)) {
      const item = byCode.get(code);
      ordered.push({
        code,
        visible: code === 'manager' ? true : item ? Boolean(item.visible) : true,
        pinned: code === 'manager' ? true : item ? Boolean(item.pinned) : false,
      });
    }
  });
  return ordered;
}

export function columnsKey(list) {
  return JSON.stringify(normalizeColumns(list).map((item) => [item.code, item.visible, item.pinned]));
}

export function pinCount(list) {
  return (list || []).filter((item) => item.pinned).length;
}

export function columnWidth(code) {
  const meta = COLUMN_META[code];
  if (!meta) return 0;
  if (meta.metric) return meta.selectedWidth + meta.currentWidth;
  return meta.width;
}

export function paneWidth(list) {
  return (list || []).reduce((sum, item) => sum + columnWidth(item.code), 0);
}

export function splitColumns(list) {
  const visible = normalizeColumns(list).filter((item) => item.visible);
  return {
    pinned: visible.filter((item) => item.pinned),
    rest: visible.filter((item) => !item.pinned),
  };
}

export function groupItems(list, group) {
  return (list || []).filter((item) => COLUMN_META[item.code] && COLUMN_META[item.code].group === group);
}

export function moveInGroup(list, code, targetCode) {
  const columns = normalizeColumns(list);
  const moving = columns.find((item) => item.code === code);
  if (!moving || code === targetCode) return columns;
  const group = COLUMN_META[code].group;
  if (targetCode && COLUMN_META[targetCode].group !== group) return columns;
  const without = columns.filter((item) => item.code !== code);
  const groupCodes = without.filter((item) => COLUMN_META[item.code].group === group).map((item) => item.code);
  let insertAt;
  if (targetCode) {
    insertAt = without.findIndex((item) => item.code === targetCode);
  } else {
    const last = groupCodes[groupCodes.length - 1];
    insertAt = last ? without.findIndex((item) => item.code === last) + 1 : without.length;
  }
  if (insertAt < 0) insertAt = without.length;
  without.splice(insertAt, 0, moving);
  return without;
}
